import { useEffect, useRef, useState } from 'react'

import '../../../styles/reports/reports-common.scss';
import { focusElement, handlekeyDown } from '../../../components/generics/helper';
import BrandAutocomplete from '../../../components/formik-form-components/BrandAutocomplete';
import CategoryAutocomplete from '../../../components/formik-form-components/CategoryAutocomplete';
import ConfirmationDialogRaw from "../../../components/generics/ConfirmationDialogRaw";
import ItemAutocomplete from '../../../components/formik-form-components/ItemAutocomplete';
import SerialNoFromInventoryAutocomplete from '../../../components/formik-form-components/SerialNoFromInventoryAutocomplete';
import SrNoWiseItemHistoryList from './SrNoWiseItemHistoryList';
import VehicleBrandAutoComplete from "../../../components/formik-form-components/VehicleBrandAutoComplete";
import VehicleModelAutoComplete from "../../../components/formik-form-components/VehicleModelAutoComplete";
import InputField from "../../../components/generics/InputField";
const SrNoWiseItemHistory = () => {
    const filterInitialValue = { searchCategoryId: '', searchCategoryName: '', searchSuperCategory: '', searchSubCategoryId: '', searchSubCategoryName: '', searchBrandId: '', searchBrandName: '', searchItemId: '', searchItemName: '', searchVehBrandId: '', searchVehBrandName: '', searchVehModelId: '', searchVehModelName: '', searchSerialNo: '', showTable: false, };
    const [srNoWiseItemHistoryFilters, setSrNoWiseItemHistoryFilters] = useState(filterInitialValue);
    const [loadData, setLoadData] = useState(false);
    const [showAlert, setShowAlert] = useState(false);

    const vehicleOEMFilterRef = useRef(null);
    const vehicleModelFilterRef = useRef(null);
    const categoryFilterRef = useRef(null);
    const subCategoryFilterRef = useRef(null);
    const brandFilterRef = useRef(null);
    const itemFilterRef = useRef(null);
    const srNoFilterRef = useRef(null);

    const srNoWiseItemHistoryFilterReset = () => {
        setSrNoWiseItemHistoryFilters({ ...filterInitialValue });
        vehicleOEMFilterRef.current.resetAutocomplete();
        vehicleModelFilterRef.current.resetAutocomplete();
        categoryFilterRef.current.resetAutocomplete();
        subCategoryFilterRef.current.resetAutocomplete();
        brandFilterRef.current.resetAutocomplete();
        itemFilterRef.current.resetAutocomplete();
        srNoFilterRef.current.resetAutocomplete();
    }

    const generateSrNoWiseItemHistoryReport = () => {
        const { searchSerialNo } = srNoWiseItemHistoryFilters;

        if (!searchSerialNo) {
            setShowAlert(true);
            return;
        }
        setSrNoWiseItemHistoryFilters(prev => ({ ...prev, showTable: true }));
        setLoadData(true);
    };

    const onAlertClose = () => {
        setShowAlert(false);
    }
    useEffect(() => {
        focusElement('searchVehOEMId')
    }, [])

    const handleSerialNoChange = (e) => {
        setSrNoWiseItemHistoryFilters(prev => ({ ...prev, searchSerialNo: e.target.value, showTable: false }));
    }
    return (
        <>
            <div key="sih_wrapper" className="report--wrapper">
                <div key="sih_filter_wrapper" className="report--filter--wrapper srNoWiseItemHistory--report--filter">
                    <div className="input--container">
                        <VehicleBrandAutoComplete
                            name="searchVehOEMId"
                            id="searchVehOEMId" nextId="searchVehModelId" prevId=""
                            isCompulsory={false}
                            singleSelect={true}
                            label={"Bus OEM"}
                            searchPlaceholder={"Search By Veh OEM"}
                            noDataLabel={"No Vehicle OEM Found"}
                            listWidth={240}
                            selectedValues={srNoWiseItemHistoryFilters?.searchVehBrandId !== '' ? [srNoWiseItemHistoryFilters.searchVehBrandId] : []}
                            onSelect={(selectedOption, currentSelection) => {
                                const searchVehBrandId = currentSelection?.vehicleOemId || '';
                                const searchVehBrandName = currentSelection?.vehicleOemName || '';
                                setSrNoWiseItemHistoryFilters(prev => ({ ...prev, searchVehBrandId, searchVehBrandName, showTable: false, }));
                            }}
                            onRemove={(selectedOption, currentSelection) => {
                                const searchVehBrandId = currentSelection?.vehicleOemId || '';
                                const searchVehBrandName = currentSelection?.vehicleOemName || '';
                                setSrNoWiseItemHistoryFilters(prev => ({ ...prev, searchVehBrandId, searchVehBrandName, showTable: false, }));
                            }}
                            onlyVehicleMappedOems={true}
                            ref={vehicleOEMFilterRef}
                        />
                    </div>
                    <div className="input--container" style={{ width: '14%' }}>
                        <VehicleModelAutoComplete
                            name="searchVehModelId"
                            id="searchVehModelId" nextId="searchCategoryId" prevId="searchVehOEMId"
                            isCompulsory={false}
                            singleSelect={true}
                            label={"Bus Model Number"}
                            searchPlaceholder={"Search By Vehicle Model"}
                            noDataLabel={"No Vehicle Model Found"}
                            listWidth={350}
                            selectedValues={srNoWiseItemHistoryFilters?.searchVehModelId !== '' ? [srNoWiseItemHistoryFilters.searchVehModelId] : []}
                            onSelect={(selectedOption, currentSelection) => {
                                const searchVehModelId = currentSelection?.vehicleModelId || '';
                                const searchVehModelName = currentSelection?.vehicleModelName || '';
                                setSrNoWiseItemHistoryFilters(prev => ({ ...prev, searchVehModelId, searchVehModelName, showTable: false, }));
                            }}
                            onRemove={(selectedOption, currentSelection) => {
                                const searchVehModelId = currentSelection?.vehicleModelId || '';
                                const searchVehModelName = currentSelection?.vehicleModelName || '';
                                setSrNoWiseItemHistoryFilters(prev => ({ ...prev, searchVehModelId, searchVehModelName, showTable: false, }));
                            }}
                            onlyVehicleMappedModels={true}
                            forOem={srNoWiseItemHistoryFilters?.searchVehBrandId}
                            ref={vehicleModelFilterRef}
                        />
                    </div>
                    <div key="sih_filter_inp_category" className="input--container">
                        <CategoryAutocomplete
                            id="searchCategoryId" nextId="searchSubCategoryId" prevId="searchVehModelId"
                            name="searchCategoryId"
                            label="Category"
                            isCompulsory={false}
                            singleSelect={true}
                            listWidth={250}
                            searchPlaceholder="Search By Category"
                            noDataLabel="No Category Found"
                            categoryFor={1}
                            isParent="Y"
                            selectedValues={srNoWiseItemHistoryFilters.searchCategoryId !== '' ? [srNoWiseItemHistoryFilters.searchCategoryId] : []}
                            onSelect={(selectedCategory, currentSelection) => {
                                const searchCategoryId = currentSelection?.categoryId || '';
                                const searchSuperCategory = currentSelection?.superCategory || '';
                                const searchCategoryName = currentSelection?.categoryTitle || '';
                                setSrNoWiseItemHistoryFilters(previousFilters => ({ ...previousFilters, searchCategoryId, searchSuperCategory, searchCategoryName, showTable: false }));
                            }}
                            onRemove={(selectedCategory, currentSelection) => {
                                const searchCategoryId = currentSelection?.categoryId || '';
                                const searchSuperCategory = currentSelection?.superCategory || '';
                                const searchCategoryName = currentSelection?.categoryTitle || '';
                                setSrNoWiseItemHistoryFilters(previousFilters => ({ ...previousFilters, searchCategoryId, searchSuperCategory, searchCategoryName, showTable: false }));
                            }}
                            ref={categoryFilterRef}
                        />
                    </div>
                    <div key="sih_filter_inp_subCategory" className="input--container">
                        <CategoryAutocomplete
                            id="searchSubCategoryId" nextId="searchBrandId" prevId="searchCategoryId"
                            name="searchSubCategoryId"
                            isCompulsory={false}
                            singleSelect={true}
                            listWidth={250}
                            label="Sub Category"
                            searchPlaceholder="Search By Sub Category"
                            noDataLabel="No Sub Category Found"
                            categoryFor={1}
                            isParent="N"
                            parentCategoryId={srNoWiseItemHistoryFilters.searchCategoryId}
                            selectedValues={srNoWiseItemHistoryFilters.searchSubCategoryId !== '' ? [srNoWiseItemHistoryFilters.searchSubCategoryId] : []}
                            onSelect={(selectedSubCategory, currentSelection) => {
                                const searchSubCategoryId = currentSelection?.categoryId || '';
                                const searchSubCategoryName = currentSelection?.categoryTitle || '';
                                setSrNoWiseItemHistoryFilters(previousFilters => ({ ...previousFilters, searchSubCategoryId, searchSubCategoryName, showTable: false }));
                            }}
                            onRemove={(selectedSubCategory, currentSelection) => {
                                const searchSubCategoryId = currentSelection?.categoryId || '';
                                const searchSubCategoryName = currentSelection?.categoryTitle || '';
                                setSrNoWiseItemHistoryFilters(previousFilters => ({ ...previousFilters, searchSubCategoryId, searchSubCategoryName, showTable: false }));
                            }}
                            ref={subCategoryFilterRef}
                        />
                    </div>
                    <div key="sih_filter_inp_brand" className="input--container" >
                        <BrandAutocomplete
                            id={'searchBrandId'} nextId="searchItemId" prevId="searchSubCategoryId"
                            name="searchBrandId"
                            label="Brand"
                            searchPlaceholder="Search By Brand Category"
                            noDataLabel="No Brand Found"
                            isCompulsory={false}
                            singleSelect={true}
                            listWidth={250}
                            brandsFor={srNoWiseItemHistoryFilters?.searchSuperCategory?.toString()}
                            selectedValues={srNoWiseItemHistoryFilters.searchBrandId !== '' ? [srNoWiseItemHistoryFilters.searchBrandId] : ['']}
                            onSelect={(selectedBrand, currentSelection) => {
                                const searchBrandId = currentSelection?.brandId || '';
                                const searchBrandName = currentSelection?.brandName || '';
                                setSrNoWiseItemHistoryFilters(previousFilters => ({ ...previousFilters, searchBrandId, searchBrandName, showTable: false }));
                            }}
                            onRemove={(selectedBrand, currentSelection) => {
                                const searchBrandId = currentSelection?.brandId || '';
                                const searchBrandName = currentSelection?.brandName || '';
                                setSrNoWiseItemHistoryFilters(previousFilters => ({ ...previousFilters, searchBrandId, searchBrandName, showTable: false }));
                            }}
                            ref={brandFilterRef}
                        />
                    </div>
                    <div key="sih_filter_inp_item" className="input--container" >
                        <ItemAutocomplete
                            id="searchItemId" nextId="searchSrNoId" prevId="searchBrandId"
                            name="searchItemId"
                            label={"Item Name"}
                            searchPlaceholder={"Search By Item Name"}
                            noDataLabel={"No Item Found"}
                            isCompulsory={true}
                            singleSelect={true}
                            listWidth={420}
                            forAllItems={'Y'}
                            forCategory={srNoWiseItemHistoryFilters?.searchCategoryId}
                            forSubCategory={srNoWiseItemHistoryFilters?.searchSubCategoryId}
                            forBrand={srNoWiseItemHistoryFilters?.searchBrandId}
                            forVehicleModels={srNoWiseItemHistoryFilters?.searchVehModelId}
                            onlySerialNoApplicable='Y'
                            onlyLoginBranchMappedModelsItems={true}
                            selectedValues={srNoWiseItemHistoryFilters.searchItemId !== '' ? [srNoWiseItemHistoryFilters.searchItemId] : []}
                            onSelect={(selectedItem, currentSelection) => {
                                const searchItemId = currentSelection?.itemId || '';
                                const searchItemName = currentSelection?.itemName || '';
                                setSrNoWiseItemHistoryFilters(previousFilters => ({ ...previousFilters, searchItemId, searchItemName, showTable: false }));
                            }}
                            onRemove={(selectedItem, currentSelection) => {
                                const searchItemId = currentSelection?.itemId || '';
                                const searchItemName = currentSelection?.itemName || '';
                                setSrNoWiseItemHistoryFilters(previousFilters => ({ ...previousFilters, searchItemId, searchItemName, showTable: false }));
                            }}
                            ref={itemFilterRef}
                        />
                    </div>
                   <div key="sih_filter_inp_serialNo" className="input--container" >
                        {srNoWiseItemHistoryFilters?.searchItemId!==''? <SerialNoFromInventoryAutocomplete
                            id='searchSrNoId' nextId="generate" prevId="searchItemId"
                            name='searchSrNoId'
                            label='Sr No'
                            searchPlaceholder={"Search By Sr No"}
                            noDataLabel={"No Sr No Found"}
                            isCompulsory={true}
                            singleSelect={true}
                            listWidth={240}
                            itemId={srNoWiseItemHistoryFilters.searchItemId}
                            selectedValues={srNoWiseItemHistoryFilters.searchSerialNo ? [srNoWiseItemHistoryFilters.searchSerialNo] : []}
                            onSelect={(selectedItem, currentSelection) => {
                                const searchSerialNo = currentSelection?.serialNo || '';
                                setSrNoWiseItemHistoryFilters(prev => ({ ...prev, searchSerialNo, showTable: false }));
                            }}
                            onRemove={(selectedItem, currentSelection) => {
                                const searchSerialNo = currentSelection?.serialNo || '';
                                setSrNoWiseItemHistoryFilters(prev => ({ ...prev, searchSerialNo, showTable: false }));
                            }}
                            ref={srNoFilterRef}
                        />:
                        <InputField name='searchSrNoId' id='searchSrNoId' label='Serial No.' isCompulsory={false} value={srNoWiseItemHistoryFilters.searchSerialNo}
                            onBlur={(e) => {handleSerialNoChange(e) }}
                            onKeyDown={(e) => { handlekeyDown(e, 'searchItemId', 'generate', 'searchSrNoId') }}
                        />}
                    </div>
                    <div className='btn--container'>
                        <div className="dashed--btn" id="generate" tabIndex="0" style={{ marginLeft: '0' }} onClick={() => { generateSrNoWiseItemHistoryReport(); }}
                            onKeyDown={(e) => { handlekeyDown(e, `searchVehOEMId`, `resetBtn`, `generate`) }}>Generate Report</div>
                        <div key="sih_filter_inp_frd" className="dashed--btn" onClick={() => srNoWiseItemHistoryFilterReset(false)}
                            id="resetBtn"
                            tabIndex="0"
                            onKeyDown={(e) => { handlekeyDown(e, `generate`, `searchVehOEMId`, `resetBtn`) }}>Reset
                        </div>
                    </div>
                </div>
                <div key="sih_container" className="report--container">
                    {srNoWiseItemHistoryFilters?.showTable && <SrNoWiseItemHistoryList srNoWiseItemHistoryFilters={srNoWiseItemHistoryFilters} loadData={loadData} setLoadData={setLoadData} />}
                </div>
                <ConfirmationDialogRaw
                    id="srNoWiseItemHistory"
                    keepMounted
                    open={showAlert}
                    cancelRequired={false}
                    onClose={onAlertClose}
                    dialogConfirmationTitle="Error"
                    dialogConfirmationMessage={"Please enter the Serial Number"}
                />
            </div>
        </>
    )
}
export default SrNoWiseItemHistory;